import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import { createBeacons, fetchBeacons, fetchBeaconsStore, fetchBeaconsTypes, SearchBeaconsStores } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { useDebounce } from '@/utils/DebounceHook';
import AddSingleBeaconDrawer from './AddSingleBeaconDrawer';
import UploadExcelDrawerr from './UploadExcelDrawer';


const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showAddBeaconDrawer: boolean;
    setshowAddBeaconDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    getBeacons: any
}
const AddBeaconDrawer: React.FC<ProductsDrawerProps> = ({ showAddBeaconDrawer, setshowAddBeaconDrawer, getBeacons }) => {
    const onCLose = () => setshowAddBeaconDrawer(false)
    const [activeTab, setActiveTab] = useState('tab1'); // State for managing active tab

    // Tab content based on active tab
    const renderContent = () => {
        switch (activeTab) {
            case 'tab1':
                return <AddSingleBeaconDrawer getBeacons={getBeacons} setshowAddBeaconDrawer={setshowAddBeaconDrawer} />;
            case 'tab2':
                return <UploadExcelDrawerr />
            default:
                return <p className="text-lg">This is the content for Tab 1: Overview of beacons.</p>;
        }
    }

    return (
        <>
            <Drawer
                title="Create Beacon"
                width={720}
                onClose={onCLose}
                open={showAddBeaconDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >
                <div className="flex space-x-4 mb-6 border-b">
                    <button
                        onClick={() => setActiveTab('tab1')}
                        className={`pb-2 px-4 text-base font-semibold ${activeTab === 'tab1' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'
                            }`}
                    >
                        upload single
                    </button>
                    <button
                        onClick={() => setActiveTab('tab2')}
                        className={`pb-2 px-4 text-base font-semibold ${activeTab === 'tab2' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'
                            }`}
                    >
                        Upload bulk
                    </button>
                </div>


                <div className="px-4 mt-11">
                    {renderContent()}
                </div>
            </Drawer>
        </>
    )
}

export default AddBeaconDrawer;


